import React from "react";
function Divider(){
    return(
        <hr className='custom-border'/>
    );
}export default Divider